// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6g-0";
export var startPickingButton = "_6g-1";